import { combineReducers, createStore, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { headerReducer } from '@volta-component-layout/Header/headerReducer';
import { cityReducer } from './extra-reducers/city';
import { provinceReducer } from './extra-reducers/province';
import { colorReducer } from './extra-reducers/color';
import { authReducer } from './extra-reducers/auth';
import { parameterReducer } from './extra-reducers/system-parameter';
import { SYNC_FROM_STORAGE } from './extra-constants/auth';

const reducers = combineReducers({
  header: headerReducer,
  city: cityReducer,
  province: provinceReducer,
  color: colorReducer,
  auth: authReducer,
  paramater: parameterReducer,
});

const persistConfig = {
  key: 'volta-web-app',
  storage,
  whitelist: ['auth', 'paramater', 'header'],
};

const composeEnhancer =
  // eslint-disable-next-line no-undef
  (process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null) || compose;

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer, composeEnhancer());
const persistor = persistStore(store);

// Global storage event listener for cross-tab synchronization
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === 'persist:volta-web-app' && event.newValue) {
      try {
        const newPersistedState = JSON.parse(event.newValue);
        const currentState = store.getState();

        // Check if auth state has changed
        if (newPersistedState.auth) {
          const newAuthState = JSON.parse(newPersistedState.auth);
          const currentAuthState = currentState.auth;

          // Only sync if there's a login (currentNavigation changes to 'main') or token updates
          // Do NOT sync logout (currentNavigation changing to 'auth')
          const isLogout =
            newAuthState.currentNavigation === 'auth' &&
            currentAuthState.currentNavigation === 'main';
          const isLogin =
            newAuthState.currentNavigation === 'main' &&
            currentAuthState.currentNavigation === 'auth';
          const hasSessionUpdates =
            JSON.stringify(newAuthState.session) !==
              JSON.stringify(currentAuthState.session) &&
            newAuthState.currentNavigation === 'main' &&
            currentAuthState.currentNavigation === 'main';

          if (isLogout) {
            // Ignore logout events from other tabs
          } else if (isLogin || hasSessionUpdates) {
            // Dispatch sync action to update the current tab's state
            store.dispatch({
              type: SYNC_FROM_STORAGE,
              payload: newAuthState,
            });
          }
        }
      } catch (error) {
        console.error('Error syncing from localStorage:', error);
      }
    }
  });
}

export { reducers, persistedReducer, persistor };

export default store;
